export class ScreeningAngle {
  minangle:number;
  maxangle:number;
  verticalangle:number;
  id:string;
  isselected : boolean = false;
  istodelete: boolean = false;
  

  public static equalsMinScreeningAngle(screeningAngle: ScreeningAngle, otherScreeningAngle: ScreeningAngle): boolean {
    return (
      screeningAngle.minangle == otherScreeningAngle.minangle
      && screeningAngle.maxangle == otherScreeningAngle.maxangle
      && screeningAngle.verticalangle == otherScreeningAngle.verticalangle
    );
  }
}
